import React from 'react';
import { useSelector } from 'react-redux';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from '@src/hooks/useFeatureFlags';

import VoiceCloningCreateContainer from '@src/containers/VoiceCloningCreate';
import { validateUserPackageCanUseVoiceCloning } from '@src/services/voiceCloning';
import useUserInfo from '@src/hooks/useTtsUser';

const VoiceCloningCreate = () => {
  const user = useSelector((state) => state.auth.user);
  const { ttsUser } = useUserInfo();

  const { getFeatureValue } = useFeatureFlags();
  const userInFeatureVoiceCloning = getFeatureValue(
    FEATURE_KEYS.VOICE_CLONING,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );
  const showVoiceCloningCreate = validateUserPackageCanUseVoiceCloning({
    ttsUser,
    isUserInWhiteList: userInFeatureVoiceCloning,
  });

  if (showVoiceCloningCreate) return <VoiceCloningCreateContainer />;
  return null;
};

export default VoiceCloningCreate;
